export const VARIANTS_ACTIONS = {
  UPDATE: 'variants/update',
  RESET: 'variants/reset',
  SET_LOADING: 'variants/set-loading',
};

export const APP_FLOW_CURRENT_STEP = {
  StartApplication: 'start-application',
  QuoteInformation: 'quote-information',
  CoverageDetails: 'coverage-details',
} as const;
